import dynamic from 'next/dynamic';
import type { ComponentProps, FC } from 'react';
const UploadFileResult = dynamic(() => import('./upload-file').then(mod => mod.UploadFileResult));
const OAuth2Result = dynamic(() => import('./oauth-result').then(mod => mod.OAuth2Result));
const NotImplementedResult = dynamic(() => import('./not-implemented').then(mod => mod.NotImplementedResult));
type UploadProps = ComponentProps<typeof UploadFileResult> & {
  kind: 'UPLOAD_FILE';
};
type OAuth2Props = ComponentProps<typeof OAuth2Result> & {
  kind: 'OAUTH2';
};
type DefaultProps = ComponentProps<typeof NotImplementedResult> & {
  kind: string;
};
type Props = UploadProps | OAuth2Props;
export const ResultSwitcher: FC<Props> = props => {
  const {
    kind,
    ...rest
  } = props;
  switch (kind) {
    case 'UPLOAD_FILE':
      return <UploadFileResult {...rest as UploadProps} />;
    case 'OAUTH2':
      return <OAuth2Result {...rest as OAuth2Props} />;
    default:
      return <NotImplementedResult />;
  }
};